var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "supporter-sub" }, [
    _c(
      "a",
      {
        class: _vm.ad.url === null ? "no-mouse" : "",
        attrs: { href: _vm.ad.url, target: "_blank" }
      },
      [
        _c("img", {
          staticClass:
            "supporter-sub d-flex justify-content-center align-items-center",
          attrs: { src: _vm.ad.image_url, alt: "Supporter Logo" }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73046b8c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73046b8c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/shared/AdTemplate.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-73046b8c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/shared/AdTemplate.vue
// module chunks = 0 1